import type {JSX} from 'react';

type HeaderProps = {
  title: string;
  children?: JSX.Element | JSX.Element[];
  icon?: React.ReactNode;
  dataCy?: string;
};
/**
 * Component to render a header
 * @param param0
 * @returns
 */
export default function Header({
  title,
  icon,
  children,
  dataCy,
}: HeaderProps): JSX.Element {
  return (
    <header className="mt-0 sm:mt-5">
      <div className="flex items-center">
        {icon && <span className="mr-2">{icon}</span>}
        <h1 className="text-xl font-semibold" data-cy={dataCy}>
          {title}
        </h1>
      </div>
      {children}
    </header>
  );
}
